//Functional compose used to compose together HOCs. Normally part of Redux

import { PhotoItem, StorageCorePhoto, Thumbnail } from "../../item"

export const constants = {
  mobileWidth: 600,
  mobileHeight: 500
}

export const compose = (...fns: ((...args: any[]) => any)[]) => fns.reduce((f: any, g: any) => (...args: any) => f(g(...args)))

// https://stackoverflow.com/questions/25991367/difference-between-throttling-and-debouncing-a-function

const postpone = (fn: () => void, time: number) => {
  return time <= 0 ? fn() : setTimeout(fn, time)
}

export function throttle(fn: (...args: any[]) => void, delay = 100) {
  let called = false,
    queued: any[] | null = null
  const action = (...args: any[]): void => {
    if (called) {
      queued = args
    } else {
      try {
        called = true
        return fn(...args)
      } finally {
        postpone(() => {
          called = false
          if (queued) {
            try {
              action(...queued)
            } finally {
              queued = null
            }
          }
        }, delay)
      }
    }
  }
  return action
}

export function debounce(fn: (...args: any) => void, delay = 100) {
  let timer: any
  return (...args: any): void => {
    clearTimeout(timer)
    timer = postpone(() => fn(...args), delay)
  }
}

export function trackScrolling(callback: Function): (event: Event) => void {
  return throttle((event: Event) => {
    const element: HTMLDivElement = event.target as HTMLDivElement
    // detect if scrolling is down and scrolled more than viewport plus equal sized threshold
    if (element.scrollTop + element.offsetHeight >= element.scrollHeight - element.offsetHeight) {
      callback()
    }
  }, 500)
}

export const mapPhotoItem = (photo: StorageCorePhoto, source: string): PhotoItem => {
  return {
    id: photo.ImageId,
    source: source,
    name: photo.Name,
    notUsable: photo.Thumbnails.length === 0,
    dateTaken: new Date(Date.parse(photo.Date) || Date.now()),
    url: photo.Url,
    urlThumbnail: getClosestThumbnail(photo.Thumbnails, 300),
    urlPreview: getClosestThumbnail(photo.Thumbnails, 1200),
    size: {
      width: photo.VisibleWidth,
      height: photo.VisibleHeight
    }
  }
}

// this works only with descending order
export const getClosestThumbnail = (thumbnails: Thumbnail[], width: number): string => {
  return thumbnails && thumbnails.length
    ? thumbnails.reduce((bestMatched, current) => {
        const matchedWith = bestMatched.Width / width
        const currentWidth = current.Width / width
        return 1 <= currentWidth && currentWidth < matchedWith ? current : bestMatched
      }).Url
    : ""
}

export const isSmallScreen = () => window.innerWidth < 600 || window.innerHeight < 600
